import { createRESTStore } from "@stores/shared/createRESTStore";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";

const useAssetTreeStore = createRESTStore({
  entityName: "assetTree",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.ASSETS,
    get: API.BASE + API.FRONTEND.ASSETS,
  },
  initialState: [],
  processResponse: {
    getItem: (response) => response.items,
  },
  additionalActions: (set, get) => ({
    initializeAssetTree: async (rootId) => {
      set((state) => ({
        ...state,
        assetTree: null,
        itemNodes: {},
        nodesOpen: {},
        favNodes: {},
        currentRootId: rootId,
        fetchingTreeItems: false,
      }));
    },

    setFetchingTreeItems: (isFetching) => {
      set({ fetchingTreeItems: isFetching });
    },

    setFavNodes: (path, isFav) => {
      set((state) => ({
        favNodes: {
          ...state.favNodes,
          [path]: isFav,
        },
      }));
    },

    setNodesOpen: (path, newValue) => {
      set((state) => ({
        nodesOpen: {
          ...state.nodesOpen,
          [path]: newValue,
        },
      }));
    },

    fetchAssetTree: async () => {
      set({ fetching: true });
      const rootIdAtStart = get().currentRootId;

      // disabling 2 level deep fetch for children to improve performance
      const includeChildren = false;

      try {
        const apiUrl =
          get().apiPaths.fetch +
          "/" +
          rootIdAtStart +
          "/children/includeChildren/" +
          includeChildren;
        const result = await apiClient.get(apiUrl);
        // apiClient wraps response in { data: {...} }
        const assets = result.data.assets;

        if (get().currentRootId !== rootIdAtStart) {
          set({ fetching: false });
          return null;
        }

        set((state) => ({
          assetTree: assets,
          fetching: false,
          //adding the children of root to the itemNodes array
          //to use it open up tree item of current page
          itemNodes: {
            ...state.itemNodes,
            [rootIdAtStart]: assets,
          },
        }));
        return assets;
      } catch (error) {
        set({ fetching: false });
        console.error("useAssetTreeStore.fetchAssetTree - Error:", error);
        return null;
      }
    },

    getAssetTreeItem: async (path) => {
      // disabling 2 level deep fetch for children to improve performance
      const includeChildren = false;

      try {
        const result = await apiClient.get(
          get().apiPaths.get +
            "/" +
            path +
            "/children/includeChildren/" +
            includeChildren,
        );
        // apiClient wraps response in { data: {...} }
        const assets = result.data.assets;
        set((state) => ({
          itemNodes: {
            ...state.itemNodes,
            [path]: assets,
          },
          nodesOpen: {
            ...state.nodesOpen,
            [path]: true,
          },
        }));
      } catch (error) {
        console.log(error);
      }
    },
  }),
});

export default useAssetTreeStore;
